module.exports = __webpack_public_path__ + "static/skilled-70ee3b480e4e3cdfb8ac5f7a6309fb99.jpg";